<div class="user-profile-settings-container no-select">

  <div class="widget-div">
    <app-auto-order-order-settings [hideActionBar]="true"></app-auto-order-order-settings>

    @if (isAdmin()) {
      <app-feature-auto-order-scheduler-settings [hideActionBar]="true"></app-feature-auto-order-scheduler-settings>

      @if (canOverridesBeViewed) {
        <app-shared-widget-container-component>
          <div title class="widget-div-heading">
            <app-display-icon
              [tooltip]="canOverridesBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
              [icon]="canOverridesBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
            </app-display-icon>
            <div>Override Settings</div>
            <app-display-icon
              [tooltip]="tooltips.overrideSettings"
              [icon]="icons.infoSlabCircleOutline"
              [colour]="iconColours.secondary">
            </app-display-icon>
          </div>
          <div block>
            <form>
              <div class="form-column">
                <div class="form-control-div toggle-item">
                  <div class="label">Order Blank Supplier Code</div>
                  <app-switch-ui
                    (checkedChange)="onToggleSwitch('orderBlankSupplierCode', $event)"
                    [ariaLabel]="'ordering-setting-order-blank-supplier-code'"
                    [checked]="orderBlankSupplierCode"
                    [size]="0.7">
                  </app-switch-ui>
                </div>
              </div>
            </form>
          </div>
          <div actions class="widget-actions">
            @if (hasOverridesBeenEdited) {
              <button
                type="button"
                class="action-button"
                [disabled]="canOverridesBeEdited === false"
                (click)="onRevertForm('overrides')">
                <app-display-icon
                  [colour]="canOverridesBeEdited === false ? iconColours.disabled : iconColours.secondary"
                  [tooltip]="tooltips.undoChanges"
                  [icon]="icons.undo">
                </app-display-icon>
              </button>
            }
            @if (canOverridesBeSubmitted) {
              <button
                type="button"
                class="action-button"
                [disabled]="isOverridesSubmitDisabled"
                (click)="onSubmitForm('overrides')">
                <app-display-icon
                  [colour]="isOverridesSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                  [tooltip]="tooltips.saveChanges"
                  [icon]="icons.contentSaveOutline">
                </app-display-icon>
              </button>
            }
          </div>
        </app-shared-widget-container-component>
      }

      @if (canPriceEditsBeViewed) {
        <app-shared-widget-container-component>
          <div title class="widget-div-heading">
            <app-display-icon
              [tooltip]="canPriceEditsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
              [icon]="canPriceEditsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
            </app-display-icon>
            <div>Order Processed Settings</div>
            <app-display-icon
              [tooltip]="tooltips.priceEditsAfterProcessed"
              [icon]="icons.infoSlabCircleOutline"
              [colour]="iconColours.secondary">
            </app-display-icon>
          </div>
          <div block>
            <form>
              <div class="form-column">
                <div class="form-control-div toggle-item">
                  <div class="label">Price Edits</div>
                  <app-switch-ui
                    (checkedChange)="onToggleSwitch('priceEditsAfterProcessed', $event)"
                    [ariaLabel]="'ordering-setting-order-edit-price-after-processed'"
                    [checked]="priceEditsAfterProcessed"
                    [size]="0.7">
                  </app-switch-ui>
                </div>
              </div>
            </form>
          </div>
          <div actions class="widget-actions">
            @if (hasPriceEditsBeenEdited) {
              <button
                type="button"
                class="action-button"
                [disabled]="canPriceEditsBeEdited === false"
                (click)="onRevertForm('priceEdits')">
                <app-display-icon
                  [colour]="canPriceEditsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                  [tooltip]="tooltips.undoChanges"
                  [icon]="icons.undo">
                </app-display-icon>
              </button>
            }
            @if (canPriceEditsBeSubmitted) {
              <button
                type="button"
                class="action-button"
                [disabled]="isPriceEditsSubmitDisabled"
                (click)="onSubmitForm('priceEdits')">
                <app-display-icon
                  [colour]="isPriceEditsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                  [tooltip]="tooltips.saveChanges"
                  [icon]="icons.contentSaveOutline">
                </app-display-icon>
              </button>
            }
          </div>
        </app-shared-widget-container-component>
      }
    }
  </div>

  <div class="ups-container-action-bar widget-actions">
    <button
      [disabled]="!haveAnyEditsBeenMade"
      type="button"
      class="action-button"
      (click)="onRevertForm('all')">
      <app-display-icon
        [colour]="iconColours.secondary"
        [tooltip]="tooltips.undoAllChanges"
        [icon]="icons.undo">
      </app-display-icon>
      Undo Changes
    </button>
    <button
      [disabled]="!haveAnyEditsBeenMade"
      type="button"
      class="action-button"
      (click)="onSubmitForm('all')">
      <app-display-icon
        [colour]="iconColours.secondary"
        [tooltip]="tooltips.saveAllChanges"
        [icon]="icons.contentSaveOutline">
      </app-display-icon>
      Save All
    </button>
  </div>

</div>
